import { createContext, useContext, type ReactNode } from 'react';
import type createOpenApiClient from 'openapi-react-query';
import type { paths } from '../api/controlPanel';
import type { createApiClient } from '../api/client';

type ApiQueries = ReturnType<typeof createOpenApiClient<paths>>;
type ApiClient = ReturnType<typeof createApiClient>;

const ApiClientCtx = createContext<{ client: ApiClient; $api: ApiQueries } | null>(null);

export function ApiClientProvider({
  client,
  $api,
  children,
}: {
  client: ApiClient;
  $api: ApiQueries;
  children: ReactNode;
}) {
  return <ApiClientCtx.Provider value={{ client, $api }}>{children}</ApiClientCtx.Provider>;
}

export function useApiClient(): ApiClient {
  const v = useContext(ApiClientCtx);
  if (!v) throw new Error('ApiClientProvider missing');
  return v.client;
}

export function useApiQueries(): ApiQueries {
  const v = useContext(ApiClientCtx);
  if (!v) throw new Error('ApiClientProvider missing');
  return v.$api;
}
